export default __webpack_public_path__ + "static/media/human-evolution.d9ff1a08.png";